import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseManagementService } from '@edtech-ui/core/services/course-management/course-management.service';
import { noFutureYearValidator } from '@edtech-ui/core/utils/noFutureYearValidator';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-course-creation-resources',
  standalone: true,
  imports: [MatIconModule, ReactiveFormsModule, CommonModule],
  templateUrl: './course-creation-resources.component.html',
  styleUrl: './course-creation-resources.component.scss'
})
export class CourseCreationResourcesComponent {

  resourcesForm!: FormGroup;
  textbookForm!: FormGroup;
  addTextbookVisible = false;
  textbooks: any[] = [];
  webResourceForm!: FormGroup;
  addWebResourceVisible = false;
  webResources: any[] = [];
  classroomId: string = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private courseService: CourseManagementService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.route.parent?.paramMap.subscribe(params => {
      this.classroomId = params.get('classroomId') ?? '';
    });

    this.resourcesForm = this.fb.group({});
    this.textbookForm = this.fb.group({
      title: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9 .,;&'-]+$/)]],
      author: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9 .,;&'-]+$/)]],
      publisher: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9 .,;&'-]+$/)]],
      year: ['', [Validators.required, Validators.pattern(/^\d{4}$/),noFutureYearValidator]],
    });
    this.webResourceForm = this.fb.group({
      url: ['', [Validators.required, Validators.pattern('https?://.+')]],
    });
    const payload = this.courseService.getPayload();
    this.textbooks = payload.textbooks || [];
    this.webResources = payload.web_references_links || [];
  }

  toggleAddTextbook() {
    this.addTextbookVisible = !this.addTextbookVisible;
  }

  cancelAddTextbook() {
    this.textbookForm.reset();
    this.addTextbookVisible = false;
  }

  saveTextbook() {
    if (this.textbookForm.invalid) {
      this.textbookForm.markAllAsTouched();

      this.toastr.warning(
        'Please complete all required fields with valid details before saving.',
        'Incomplete or Invalid Information'
      ); return;
    }

    this.textbooks.push(this.textbookForm.value);
    this.courseService.updatePayload({ textbooks: this.textbooks });
    this.textbookForm.reset();
    this.addTextbookVisible = false;
  }
  toggleAddWebResource() {
    this.addWebResourceVisible = !this.addWebResourceVisible;
  }
  cancelAddWebResource() {
    this.webResourceForm.reset();
    this.addWebResourceVisible = false;
  }

  saveWebResource() {
    if (this.webResourceForm.invalid) {
      this.webResourceForm.markAllAsTouched();
      this.toastr.warning('Please enter a valid URL starting with http:// or https://', 'Invalid URL');
      return;
    }

    const url = this.webResourceForm.value.url;
    this.webResources.push(url);
    this.courseService.updatePayload({ web_references_links: this.webResources });
    this.webResourceForm.reset();
    this.addWebResourceVisible = false;
  }
  editTextbook(index: number) {
    const selectedBook = this.textbooks[index];
    this.textbookForm.patchValue(selectedBook);
    this.addTextbookVisible = true;
    this.textbooks.splice(index, 1);
    this.courseService.updatePayload({ textbooks: this.textbooks });
  }

  deleteTextbook(index: number) {
    this.textbooks.splice(index, 1);
    this.courseService.updatePayload({ textbooks: this.textbooks });
    this.toastr.info('Textbook deleted successfully');
  }


  editWebResource(index: number) {
    const url = this.webResources[index];
    this.webResourceForm.patchValue({ url });
    this.addWebResourceVisible = true;
    this.webResources.splice(index, 1);
    this.courseService.updatePayload({ web_references_links: this.webResources });
  }

  deleteWebResource(index: number) {
    this.webResources.splice(index, 1);
    this.courseService.updatePayload({ web_references_links: this.webResources });
    this.toastr.info('Web Resource deleted successfully');
  }


  goToPrePage() {
    this.router.navigate(['/teacher-dashboard', this.classroomId, 'manual-course-creation', 'course-outcome']);
  }

  goToNextPage() {
    this.router.navigate(['/teacher-dashboard', this.classroomId, 'manual-course-creation', 'course-preview']);
  }
}
